<template>
    <div class="warp">
      <HomePage/>
    </div>
</template>

<script>
import HomePage from '../components/Home.vue'

export default {
    components: {
        HomePage,
    },
    data(){
        return{
           
        }
    },
}
</script>

<style>
.warp {
    height: 100%;
    overflow: auto;
}
</style>
